import { render, staticRenderFns } from "./Editable.vue?vue&type=template&id=533d02ec&scoped=true&"
import script from "./Editable.vue?vue&type=script&lang=js&"
export * from "./Editable.vue?vue&type=script&lang=js&"
import style0 from "./Editable.vue?vue&type=style&index=0&id=533d02ec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533d02ec",
  null
  
)

export default component.exports